import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { FaIcon, FaLayer } from './etc/icons'
import LogMixin from './etc/log.mixin'
import UiMixin from './etc/ui.mixin'
import { LOG } from './etc/log'
import { QuillEditor } from '@vueup/vue-quill'
import { clickOutside } from './etc/click-outside.directive'
import { DND } from './etc/dnd.directives'
import { initRangeProgress } from './etc/rangeProgress'
import { installTitleFontDebugHelper } from '@/editor/text/fontLoader'
import { installAiElementsDebug } from '@/etc/aiElements.debug'
import { installPersonalityChipDebug } from '@/etc/personalityChip.debug'
import { installAiWorkflowPresetsDebug } from '@/etc/aiWorkflowPresets.debug'
import {
  SPEED_PHASE0_TERMS,
  SPEED_PHASE0_ACCEPTANCE,
  SPEED_PHASE0_GOLDEN_SCENARIOS,
  SPEED_PHASE7_GOLDEN_SCENARIOS,
  runSpeedPhase0GoldenScenarios,
  runSpeedPhase7GoldenScenarios,
  summarizeStripSpeedModel,
} from '@/editor/timing/speedParityPhase0'
import 'bootstrap/scss/bootstrap.scss'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import '@vueup/vue-quill/dist/vue-quill.bubble.css'
import '@/assets/vyby.scss'

import ace from 'ace-builds'
import workerJsonUrl from 'file-loader?esModule=false!ace-builds/src-noconflict/worker-json.js' // For webpack / vue-cli
// import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/mode-liquid'
import 'ace-builds/src-noconflict/theme-terminal'
import { VAceEditor } from 'vue3-ace-editor'

// import Tracker from '@openreplay/tracker';

// const tracker = new Tracker({
// projectKey: "UmDMZwi5uhVmCm4CXqGw",
// });
// tracker.start();

ace.config.setModuleUrl('ace/mode/json_worker', workerJsonUrl)

const log = LOG.m('main.js')

const DEV_BYPASS_AUTH_KEY = 'vyby/devBypassAuth'

const isDevBypassAuthEnabled = (to) => {
  if (process.env.NODE_ENV === 'production') return false
  if (process.env.VUE_APP_DEV_BYPASS_AUTH === 'true') return true

  const q = to?.query?.devBypassAuth
  if (q === '1' || q === 'true') {
    if (typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.setItem(DEV_BYPASS_AUTH_KEY, 'true')
    }
    return true
  }

  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage.getItem(DEV_BYPASS_AUTH_KEY) === 'true'
  }
  return false
}

router.beforeEach(async (to) => {
  if (!store.state.initialized) await store.dispatch('init')
  document.body.classList = [`page-${to.name}`]
  // log.debug('route to', to)
  // Dev convenience: optionally bypass auth for all routes
  if (isDevBypassAuthEnabled(to)) return true
  // Dev convenience: go straight to editor and bypass auth for editor
  if (process.env.NODE_ENV !== 'production') {
    if (to.path === '/' || to.name === 'home') return { name: 'editor' }
    if (to.name === 'editor' || to.name === 'projects') return true
  }
  if (to.meta.authorized) {
    if (store.state.user.uid) return true
    log.warn('unauthorized access attempt to', to)
    store.commit('user/redirectAfterLogin', to.fullPath)
    if (to.meta.admin) return { name: 'not-authorized' }
    else return { name: 'beta' }
  }
  return true
})

const app = createApp(App)
  .use(store)
  .use(router)
  .component('fa-icon', FaIcon)
  .component('fa-layer', FaLayer)
  .component('quill-editor', QuillEditor)
  .component('v-ace-editor', VAceEditor)
  .mixin(LogMixin)
  .mixin(UiMixin)
  .directive('click-outside', clickOutside)
DND(app, store)
app.mount('#app')
initRangeProgress()
installTitleFontDebugHelper()

if (process.env.NODE_ENV !== 'production') {
  installAiElementsDebug(store)
  installPersonalityChipDebug(store)
  installAiWorkflowPresetsDebug(store)
}

if (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined') {
  window.vybySpeedPhase0 = {
    contracts() {
      return {
        terms: SPEED_PHASE0_TERMS,
        acceptance: SPEED_PHASE0_ACCEPTANCE,
        scenarios: SPEED_PHASE0_GOLDEN_SCENARIOS,
        phase7Scenarios: SPEED_PHASE7_GOLDEN_SCENARIOS,
      }
    },
    runGolden(opts = {}) {
      return runSpeedPhase0GoldenScenarios(opts)
    },
    runPhase7(opts = {}) {
      return runSpeedPhase7GoldenScenarios(opts)
    },
    activeStrip() {
      const project = store.state.project || {}
      const t = project.timeline || {}
      const track = project.tracks?.[t.activeTrack]
      const strip = track?.strips?.[t.activeStrip]
      if (!strip) return null
      return summarizeStripSpeedModel(strip)
    },
  }
}
